import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { useQualiopi } from '@/hooks/useQualiopi';

interface TypeformButtonProps {
  formType: 'complaint';
  variant?: 'default' | 'outline' | 'destructive';
  size?: 'default' | 'sm' | 'lg';
  className?: string;
}

export function TypeformButton({ 
  formType, 
  variant = 'outline', 
  size = 'default', 
  className = '' 
}: TypeformButtonProps) {
  const { user } = useAuth();
  const { getComplaintFormUrl, loading } = useQualiopi();

  // Ne pas afficher si l'utilisateur n'est pas connecté
  if (!user) {
    return null;
  }

  const url = getComplaintFormUrl();
  
  // Afficher un état de chargement au lieu de disparaître
  if (!url && loading) {
    return (
      <Button 
        variant={variant}
        size={size}
        className={className}
        disabled
      >
        <div className="mr-2 h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
        Chargement...
      </Button>
    );
  }
  
  // Si pas d'URL et pas de chargement, il y a un problème de configuration
  if (!url) {
    console.error('Aucune URL de réclamation trouvée dans la configuration Typeform');
    return (
      <Button 
        variant="outline"
        size={size}
        className={className}
        disabled
      >
        <AlertTriangle className="mr-2 h-4 w-4" />
        Configuration manquante
      </Button>
    );
  }

  const handleClick = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Button 
      onClick={handleClick}
      variant={variant}
      size={size}
      className={className}
    >
      <AlertTriangle className="mr-2 h-4 w-4" />
      Réclamation
    </Button>
  );
}